import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import api, { imgSrc } from "@/lib/api";
import { SectionHeading, revealProps } from "@/components/lux";

export default function InstagramSection({ settings = {} }) {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/instagram").then((r) => setPosts(r.data)).catch(() => {}); }, []);
  if (!posts.length) return null;

  return (
    <section className="relative py-24 sm:py-32 bg-[#050708]" data-testid="instagram-section">
      <div className="mx-auto max-w-[1300px] px-5 sm:px-8">
        <div className="flex items-end justify-between gap-4 flex-wrap">
          <motion.div {...revealProps()}>
            <SectionHeading eyebrow="On The Grid" title="Latest on Instagram" />
          </motion.div>
          {settings.instagram && (
            <motion.a
              {...revealProps(0.1)}
              href={settings.instagram}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 rounded-full border border-white/15 px-5 py-2.5 text-sm font-mono2 text-white/80 hover:border-[#02AACF] hover:text-[#02AACF] transition-colors"
              data-testid="instagram-follow"
            >
              <Instagram size={16} /> Follow
            </motion.a>
          )}
        </div>
        <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
          {posts.map((p, i) => (
            <motion.a
              key={p.id}
              {...revealProps((i % 4) * 0.06)}
              href={p.link || settings.instagram || "#"}
              target="_blank"
              rel="noreferrer"
              className="group relative aspect-square overflow-hidden rounded-xl border border-white/10 bg-[#12141C]"
              data-testid={`instagram-post-${i}`}
            >
              <img
                src={imgSrc(p, 700)}
                alt={p.caption || "LUHAI on Instagram"}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/45 transition-colors flex items-center justify-center">
                <Instagram className="text-white opacity-0 group-hover:opacity-100 transition-opacity" size={26} />
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
